const $ = require('jquery')

$.support.cors = true

function objectifyForm(formArray) {
  //serialize data function
  var returnArray = {};
  for (var i = 0; i < formArray.length; i++){
      returnArray[formArray[i]['name']] = formArray[i]['value']
  }
  return returnArray;
}

const send = body => {
  const data = {
    type: 'support',
    subject: 'Suporte',
    ...objectifyForm(body)
  }
  $.ajax({
    type: 'POST',
    url: 'https://api.clubedotruco.com.br/messages',
    data: JSON.stringify(data),
    contentType: 'application/json; charset=utf-8',
    dataType: 'json'
  })
}

$(function(){

  const form = $('#form-support')
  const success = $('#alert-success')

  $('#close-alert').on('click', function(e) {
    e.preventDefault()
    success.addClass('hidden')
    window.location.href = '/'
  })

  form.on('submit', function(e) {
    e.preventDefault()
    const textareaValue = $('#message').val().trim()

    if (textareaValue === '') {
      alert('Por favor, insira uma mensagem.')
      return false
    }
    send($(this).serializeArray())
    success.removeClass('hidden')
    return false
  })
})
